import { render, staticRenderFns } from "./orderManagementList.vue?vue&type=template&id=1515e9c6&scoped=true"
import script from "./orderManagementList.vue?vue&type=script&lang=js"
export * from "./orderManagementList.vue?vue&type=script&lang=js"
import style0 from "./orderManagementList.vue?vue&type=style&index=0&id=1515e9c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1515e9c6",
  null
  
)

export default component.exports